// Экраны, которые есть только на сайте (без Telegram): «Мои заказы».

import { useEffect, useState } from 'react';
import { api } from '../lib/api.ts';
import { useApp } from '../lib/store.tsx';
import { track } from '../lib/events.ts';
import { dayWord } from '../lib/format.ts';
import { ErrorNote, Flower, Icon, Spinner, TitleTop } from '../ui/kit.tsx';

/** Заказы этого браузера и ссылки на почту — для заказов с другого устройства. */
export function MyOrders() {
  const { me, go } = useApp();
  const [email, setEmail] = useState(me?.user.email ?? '');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (me?.user.email) setEmail((v) => v || me.user.email || '');
  }, [me]);
  const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

  return (
    <main className="screen">
      <TitleTop title="Мои заказы" />
      {!me ? (
        <Spinner />
      ) : me.orders.length ? (
        <div className="stack">
          {me.orders.map((o) => (
            <button key={o.publicId} type="button" className="tile" onClick={() => go({ name: 'order', orderId: o.publicId })} style={{ minHeight: 64 }}>
              <Flower fill={o.recipientName ? '#F7ACD6' : '#FEEB9E'} size={30} />
              <span className="stack s6" style={{ gap: 2, flex: 1, textAlign: 'left' }}>
                <span style={{ fontWeight: 600 }}>
                  {o.kind === 'surprise' ? 'Сюрприз' : o.kind === 'individual' ? 'Индивидуальный букет' : o.designName}, {o.size}
                </span>
                <span className="tiny">
                  {o.publicId} · {dayWord(o.date)} · {o.statusText}
                </span>
              </span>
              <Icon name="next" size={18} />
            </button>
          ))}
        </div>
      ) : (
        <p className="p">В этом браузере заказов пока нет.</p>
      )}

      <div className="card stack">
        <span className="h2" style={{ fontSize: 20 }}>
          Заказ с другого устройства?
        </span>
        <span className="small">Пришлём на почту ссылки на все заказы с ней. Входить никуда не нужно.</span>
        {sent ? (
          <div className="status">
            <Icon name="check" size={20} width={2.6} />
            Отправили, проверь почту и папку «Спам»
          </div>
        ) : (
          <>
            <input className="input" type="email" inputMode="email" autoComplete="email" placeholder="Почта" value={email} onChange={(e) => setEmail(e.target.value)} aria-label="Почта" />
            <ErrorNote error={error} />
            <button
              type="button"
              className="btn"
              disabled={!valid || busy}
              onClick={async () => {
                setBusy(true);
                setError(null);
                try {
                  await api.myOrders(email.trim());
                  track('site_my_orders', { sent: true });
                  setSent(true);
                } catch (e: any) {
                  setError(e.message);
                } finally {
                  setBusy(false);
                }
              }}
            >
              Прислать ссылки
            </button>
          </>
        )}
      </div>
    </main>
  );
}
